import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAdsList = Loadable({
  loader: function loader() {
    return import('../AdsList.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAdsList;